export const DISTRICT_ADMIN = 'district admin';
export const GLOBAL_ADMIN = 'global admin';
export const INSTRUCTOR = 'instructor';
export const LITERACY_CHAMPION = 'literacy champion';
export const LITERACY_COACH = 'literacy coach';
export const LITERACY_OUTCOMES_SPECIALIST = 'literacy outcomes specialist';
export const SCHOOL_ADMIN = 'school admin';
export const TEACHER = 'teacher';



// WEBPACK FOOTER //
// ./frontend/shared/js/lib/roles.js